import { BatterySummary } from "@inrange/building-manager-api-client/models-site";
import { formatUnits } from "../../formatting/formatKiloUnits";
import { formatBatterySummary } from "../../formatting/formatting-utils";

export const getProcurementNote = (
  hasOnsiteBehindMeter: boolean,
  numNetworkImportSites: number,
  installedCapacity: number,
  batterySummary?: BatterySummary
): string | undefined => {
  let procurementNote: string | undefined = undefined;
  if (hasOnsiteBehindMeter) {
    procurementNote = `from ${formatUnits(installedCapacity, "kWp", 1)} system`;
    if (batterySummary) {
      procurementNote += ` with a ${formatBatterySummary(batterySummary)} battery`;
    }
    if (numNetworkImportSites > 0) {
      procurementNote += ` and ${numNetworkImportSites} network sites`;
    }
  } else if (numNetworkImportSites > 0) {
    procurementNote = `from ${numNetworkImportSites} network sites`;
  }
  return procurementNote;
};
